import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {PointId} from '../../../shared/models/point';
import {Protocol} from '../../../shared/models/protocol';

@Component({
    selector: 'motn-point-definition-pill',
    templateUrl: './point-definition-pill.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./point-definition-pill.component.scss'],
})
export class PointDefinitionPillComponent implements OnInit {

  @Input() protocol: Protocol;
  @Input() pointId: PointId;
  @Input() pillShape: boolean = true;

  renderedTextParts: string[];


  constructor() {
  }


  ngOnInit(): void {
    switch (this.protocol) {
      case 'bacnet': {
        const parts: [string, string] = JSON.parse(this.pointId);
        this.renderedTextParts = [
          'BACnet/IP',
          `${parts[0]} ${parts[1]}`,
        ];
        break;
      }
      case 'modbus': {
        const parts: [string, number, string, boolean] = JSON.parse(this.pointId);
        this.renderedTextParts = [
          'Modbus TCP',
          // parts[0],
          'Address ' + parts[1],
        ];
        break;
      }
      case 'lorawan': {
        const parts: [string, string, string] = JSON.parse(this.pointId);
        this.renderedTextParts = [
          'LoRaWAN',
          parts[1],
        ];
        break;
      }
      case 'formula': {
        this.renderedTextParts = ['Formula'];
        break;
      }
      default: {
        this.renderedTextParts = [];
      }
    }
  }
}
